import React from "react";

import Typography from "@mui/material/Typography";

import ConfirmationModal, {
  ConfirmationModalProps,
} from "@rui/ConfirmationModal";

const RemoveTopicReportConfirmationModal = (
  props: Omit<ConfirmationModalProps, "children">
) => (
  <ConfirmationModal
    {...props}
    confirmProps={{ type: "negative", label: "Remove report" }}
    title="Remove Report?"
    size="md"
  >
    <Typography variant="bodyPrimaryReg" color="shades.neutral.600">
      Removing this report means you will no longer be able to view it. This
      action is permanent and cannot be undone.
    </Typography>
  </ConfirmationModal>
);

export default RemoveTopicReportConfirmationModal;
